

    const FETCH_RANDOM_MEAL = "FETCH_RANDOM_MEAL";
    const FETCH_CATEGORIES = "FETCH_CATEGORIES";
    const FETCH_RECIPES_MAP = "FETCH_RECIPES_MAP";
    const FETCH_CATEGORY_SELECTED = "FETCH_CATEGORY_SELECTED";
    const GET_RECIPE = "GET_RECIPE";
    const GET_QUERY  = "GET_QUERY";
    const QUERY_INPUT  = "QUERY_INPUT";
     
    const ADD_FAV = "ADD_FAV";
    const REMOVE_FAV = "REMOVE_FAV";
    
    const GET_NOTIFICATION = "GET_NOTIFICATION";
    
     
    
    export {FETCH_RANDOM_MEAL, FETCH_CATEGORIES,FETCH_RECIPES_MAP, FETCH_CATEGORY_SELECTED, GET_RECIPE, GET_QUERY, ADD_FAV, REMOVE_FAV,     GET_NOTIFICATION, QUERY_INPUT};